"use strict";
/**
 * Transforms wkt coordinates of polygons or multipolygons into an svg of your shape.
 * @param shape - Wkt coordinates ej: POLYGON((1 1,5 1,5 5,1 5,1 1),(2 2,2 3,3 3,3 2,2 2)) OR MULTIPOLYGON(((1 1,5 1,5 5,1 5,1 1),(2 2,2 3,3 3,3 2,2 2)),((1 1,5 1,5 5,1 5,1 1),(2 2,2 3,3 3,3 2,2 2))).
 * @param width - Width size ej: 45.
 * @param height - Height size ej: 45.
 * @returns - Shape svg.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function wktToSvgShape(shape, width = 100, height = 100) {
    if (!shape) {
        return svgCircle(width, height);
    }
    let polygons = polygon_parse(shape);
    polygons = polygons.map(polygon_projection);
    polygons = polygons.map((points) => polygon_normalize(points, width, height, 5));
    let path = '';
    polygons.forEach(points => {
        points.forEach((p, i) => {
            path += i === 0 ? 'M ' : 'L ';
            path += p[0] + ' ' + p[1] + ' ';
        });
        path += 'Z '; // Close the path for each polygon
    });
    return `
        <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
            <path d="${path}" />
        </svg>     
    `;
}
exports.default = wktToSvgShape;
function svgCircle(width, height) {
    const cx = width / 2;
    const cy = height / 2;
    const r = Math.min(cx, cy) * 0.75;
    return `
        <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
            <circle cx="${cx}" cy="${cy}" r="${r}" />
        </svg>     
    `;
}
function polygon_parse(poly) {
    poly = poly.replace(/\s+/g, ' ').trim();
    // Check if the input is a POLYGON or MULTIPOLYGON
    if (poly.startsWith('POLYGON')) {
        poly = poly.replace('POLYGON', '').replace(/\(/g, '').replace(/\)/g, '');
        const points = poly.split(',');
        return [points.map((point) => point.trim().split(' ').map((p) => +p))];
    }
    else if (poly.startsWith('MULTIPOLYGON')) {
        poly = poly.replace('MULTIPOLYGON', '').replace(/\)\s*\(/g, '||').replace(/\(/g, '').replace(/\)/g, '');
        const polygons = poly.split('||');
        return polygons.map(polygon => {
            const points = polygon.split(',');
            return points.map((point) => point.trim().split(' ').map((p) => +p));
        });
    }
    else {
        throw new Error('Unsupported shape format');
    }
}
function polygon_projection(points) {
    const RAD2DEG = 180 / Math.PI;
    const PI_4 = Math.PI / 4;
    const lat2y = (lat) => Math.log(Math.tan((lat / 90 + 1) * PI_4)) * RAD2DEG;
    const lon2x = (lon) => lon;
    return points.map(([x, y]) => {
        return [
            lon2x(x),
            lat2y(y * -1),
        ];
    });
}
function polygon_normalize(points, width, height, margin = 0) {
    width -= margin * 2;
    height -= margin * 2;
    let min_a = points[0][0];
    let max_a = points[0][0];
    let min_b = points[0][1];
    let max_b = points[0][1];
    for (const p of points) {
        min_a = Math.min(p[0], min_a);
        max_a = Math.max(p[0], max_a);
        min_b = Math.min(p[1], min_b);
        max_b = Math.max(p[1], max_b);
    }
    const diff_a = max_a - min_a;
    const diff_b = max_b - min_b;
    const scale_a = diff_a > 0 ? width / diff_a : 100000;
    const scale_b = diff_b > 0 ? height / diff_b : 100000;
    const scale = Math.min(scale_a, scale_b);
    const size_a = diff_a * scale;
    const size_b = diff_b * scale;
    const offset_a = (width - size_a) / 2;
    const offset_b = (height - size_b) / 2;
    return points.map((p) => [
        (p[0] - min_a) * scale + offset_a + margin,
        (p[1] - min_b) * scale + offset_b + margin,
    ]);
}
